// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pLco","colMin":"styles_colMin__LoCaY"};